import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { withNamespaces } from "react-i18next";
import { REPORT_PRIMARY_COLOR, REPORT_PRIMARY_TEXT_COLOR } from "../../helpers";

const Footer = ({ backgroundColor = REPORT_PRIMARY_COLOR, t }) => {
    const styles = StyleSheet.create({
        footer: {
            backgroundColor: backgroundColor || REPORT_PRIMARY_COLOR,
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            height: 27,
            paddingLeft: 58,
            display: 'flex',
            justifyContent: 'center'
        },
        pageNumber : {
            fontSize: 10,
            color: REPORT_PRIMARY_TEXT_COLOR,
        }
    });

    return (
        <View style={styles.footer} fixed>
            <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `${t('Page')} ${pageNumber}/${totalPages}`} />
        </View>
    );
};

export default withNamespaces()(Footer);